export const EMAIL_LANDING_PLANS: SubscriptionModel[] = [
  {
    id: 1,
    fullPrice: 6.6,
    fullPrice_new: 4.2,
    planName: 'Email Plan',
    planNameUpper: '',
    periodKey: 'subscription_period_1week',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 0,
      roundedDiscPrice: 0,
      chargebeeId: 'kegel_5-USD-Weekly',
    },
    fitness: {
      id: 1,
      fullPrice: 2.49,
      periodKey: 'subscription_period_1week',
      planNameUpper: '',
      currencyCode: 'USD',
      currencySymbol: '$',
      standard: {
        chargebeeId: 'Fitness_2-USD-Weekly',
        discPrice: 1.74,
        roundedDiscPrice: 174,
      },
      super: {
        chargebeeId: 'Fitness_3-USD-Weekly',
        discPrice: 0.99,
        roundedDiscPrice: 99,
      },
    },
  },
  {
    id: 2,
    fullPrice: 6.6,
    fullPrice_new: 4.2,
    planName: 'Email Plan',
    planNameUpper: '',
    periodKey: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 0,
      roundedDiscPrice: 0,
      chargebeeId: 'kegel_5f-USD-Weekly',
    },
  },
  {
    id: 3,
    fullPrice: 6.6,
    fullPrice_new: 4,
    planName: 'Email Plan',
    planNameUpper: '',
    periodKey: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 0,
      roundedDiscPrice: 0,
      chargebeeId: 'kegel_6-USD-Weekly',
    },
  },
  {
    id: 4,
    fullPrice: 6.6,
    fullPrice_new: 3.3,
    planName: 'Email Plan',
    planNameUpper: '',
    periodKey: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 0,
      roundedDiscPrice: 0,
      chargebeeId: 'kegel_7-USD-Weekly',
    },
  },
  {
    id: 5,
    fullPrice: 79.2,
    fullPrice_new: 5.97,
    planName: 'Email Plan',
    planNameUpper: '',
    periodKey: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 0,
      roundedDiscPrice: 0,
      chargebeeId: 'kegel_8-USD-Every-3-months',
    },
  },
];
